import React from 'react'

const Manual_kds_pantallas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">InvuKDS Configuración - Pantallas</h2>
        <iframe
          src="https://scribehow.com/embed/InvuKDS_Configuracion__Pantallas__XOEm5V0MTGq_O4Lwf7wPKw?as=scrollable"
          className="scribe-iframe-general-196"
          width="100%"
          height="4300"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_kds_pantallas
